import axios, { AxiosResponse } from "axios";
import { LicensesUrl } from "./AUrl";

/*
The interface for the response from the assign/unassign license endpoints.

@status: The HTTP status code.
@error: The error message if any.
@message: The success message if applicable.
*/
export interface LicenseResponse {
    status: number;
    error?: string;
    message?: string;
}

// Function Signatures
export type AssignLicenseType = (
    jwt: string,
    userId: number,
    licenseKey: string,
) => Promise<LicenseResponse>;
export type UnassignLicenseType = (
    jwt: string,
    userId: number,
    licenseKey: string,
) => Promise<LicenseResponse>;

/*
The function to assign a license to a user.

@jwt: The JWT of the user making the request.
@userId: The ID of the user receiving the license.
@licenseKey: The license key being assigned.

@returns: The ApiResponse from the assign license endpoint.
*/
export async function assignLicense(
    jwt: string,
    userId: number,
    licenseKey: string,
): Promise<LicenseResponse> {
    const url = new LicensesUrl().assign;
    if (!jwt) {
        return { status: 401, error: "JWT has expired" };
    }

    let response: AxiosResponse<any>;
    try {
        response = await axios.post<LicenseResponse | string>(
            url,
            { user_id: userId, license_key: licenseKey },
            {
                headers: {
                    "Content-Type": "application/json",
                    token: jwt,
                },
                validateStatus: () => true, // Resolve promise for all HTTP status codes
            },
        );
    } catch (error) {
        return {
            status: 500,
            error: "Network or other error occurred",
        };
    }

    return response.status === 201
        ? { status: response.status, message: response.data as string }
        : { status: response.status, error: response.data as string };
}
